import React from "react";
import DatePicker from 'react-datepicker';
import "@/components/forms/datepicker_fix.scss";

interface IProps {
    value?: Date;
    newValue: (value: Date | null) => void;
}

const DatePickerComponent: React.FC<IProps> = ({ value, newValue }) => {
    
    if (typeof(value) === "string"){
        value = new Date(value);
    }

    const years: number[] = [];
    for (let i = 2017; i <= new Date().getFullYear()+2; i++) {
        years.push(i);
    }

    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    return (
        <DatePicker
            className="w-full px-2"
            placeholderText="Payment Date"
            selected={value}
            onChange={(date) => newValue(date)}
            calendarStartDay={1}
            dateFormat="dd/MM/yyyy"
            tabIndex={1}
            renderCustomHeader={({
                date,
                changeYear,
                changeMonth,
                decreaseMonth,
                increaseMonth,
                prevMonthButtonDisabled,
                nextMonthButtonDisabled,
            }) => (
                <div
                    style={{
                        margin: 10,
                        display: "flex",
                        justifyContent: "center",
                    }}
                    tabIndex={-1}
                >
                    <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} tabIndex={-1}>
                        {"<"}
                    </button>

                    <select
                        value={months[date.getMonth()]}
                        onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}
                        tabIndex={-1}
                    >
                        {months.map((option) => (
                            <option key={option} value={option} tabIndex={-1}>
                                {option}
                            </option>
                        ))}
                    </select>

                    <select
                        value={date.getFullYear()}
                        onChange={({ target: { value } }) => changeYear(Number(value))}
                        tabIndex={-1}
                    >
                        {years.map((option) => (
                        <option key={option} value={option} tabIndex={-1}>
                            {option}
                        </option>
                        ))}
                    </select>

                    <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} tabIndex={-1}>
                        {">"}
                    </button>
                </div>
            )}
        />
    )
}

export default DatePickerComponent;